import "./location-updates.css";

import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import {
	Grid,
	GridColumn,
	GridNoRecords,
} from "@tql/ui-components-react/kendo/grid";
import { filesErrorIcon } from "@tql/ui-components-react/kendo/svg-icons";
import { useMemo, useState } from "react";

export type LocationUpdateRow = {
	dateTime: string;
	sortDate: string;
	status: string;
	location: string;
	distance: string;
	latitude: number | null;
	longitude: number | null;
};

const COLLAPSED_VISIBLE_UPDATES = 5;
const EXPANDED_VISIBLE_UPDATES = 12;

export const LocationUpdates = ({
	updates,
	hideTrackingData = false,
	distanceToNextStop,
}: {
	updates: LocationUpdateRow[];
	hideTrackingData?: boolean | null;
	distanceToNextStop?: string | null;
}) => {
	const [isExpanded, setIsExpanded] = useState(false);

	const visibleCount = isExpanded ? updates.length : COLLAPSED_VISIBLE_UPDATES;

	const locationRows = useMemo(
		() =>
			hideTrackingData
				? []
				: updates.slice(0, visibleCount).map((update) => ({
						date: update.dateTime,
						status: update.status,
						location: update.location,
					})),
		[updates, hideTrackingData, visibleCount],
	);

	const showToggle = updates.length > COLLAPSED_VISIBLE_UPDATES;
	const needsScroll = isExpanded && updates.length > EXPANDED_VISIBLE_UPDATES;

	return (
		<div>
			{distanceToNextStop != null && distanceToNextStop !== "" ? (
				<div className={"location-updates-distance-to"}>
					<h6 className={"location-updates-distance-to-label"}>
						Distance to next stop:
					</h6>{" "}
					<span className={"location-updates-distance-to-value"}>
						{distanceToNextStop}
					</span>
				</div>
			) : null}
			<div
				className={
					needsScroll ? "location-updates-scroll-container" : undefined
				}
			>
				<Grid
					className={"location-updates-grid"}
					data={locationRows}
					scrollable={"none"}
				>
					<GridNoRecords>
						<div className={"location-updates-no-results"}>
							<SvgIcon icon={filesErrorIcon} size={"xlarge"} />
							{hideTrackingData ? (
								<p>Location updates not yet available.</p>
							) : (
								<p>No results found</p>
							)}
						</div>
					</GridNoRecords>
					<GridColumn field={"date"} title={"Date/Time(EST)"}></GridColumn>
					<GridColumn field={"location"} title={"Location"}></GridColumn>
					<GridColumn field={"status"} title={"Status"}></GridColumn>
				</Grid>
			</div>
			{showToggle ? (
				<button
					className={"location-updates-toggle"}
					onClick={() => setIsExpanded((prev) => !prev)}
					type={"button"}
				>
					{isExpanded ? "- View less" : "+ View more"}
				</button>
			) : null}
		</div>
	);
};
